import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useState } from 'react';

const ENDPOINT_URL = '/str-stores/my-account/{uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetMyAccountStoreDetailInput = paths[url]['get']['parameters']['path'];
export type GetMyAccountStoreDetailSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get a user's store.
 */
export const useGetMyAccountStoreDetail = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setMyAccountStoreDetail, setIsLoadingMyAccountStoreDetail } = useData();
    const [error, setError] = useState<string | null>(null);
    const [statusCode, setStatusCode] = useState<number | null>(null);

    const request = async (props: GetMyAccountStoreDetailInput) => {
        setIsLoadingMyAccountStoreDetail(true);
        setError(null);
        setStatusCode(null);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{uuid}', props.uuid || '')}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                let errorMessage = '';
                let currentStatusCode = response.status;
                const json = await response.json();
                errorMessage = json.message;
                setError(errorMessage);
                setStatusCode(currentStatusCode);
                return;
            }

            const data: GetMyAccountStoreDetailSuccessResponse = await response.json();
            setMyAccountStoreDetail(data);

        } catch (originalError: any) {
            handleCommonErrors(originalError);
            const apiError = originalError as ApiError;
            setError(apiError?.message);
            setStatusCode(apiError?.statusCode);
        } finally {
            setIsLoadingMyAccountStoreDetail(false);
        }
    };

    return { request, error, statusCode };
};